(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["community-launch"] && !Shopify.designMode) return;
  try {
    
  function initialiseCommunityPassword(root) {
    const input = root.querySelector('.cb-launch__password-input input');
    const toggle = root.querySelector('[data-password-toggle]');
    if (!input || !toggle) return;
    const showIcon = toggle.querySelector('[data-password-show-icon]');
    const hideIcon = toggle.querySelector('[data-password-hide-icon]');
    function setVisible(visible) {
      const focused = document.activeElement;
      const start = input.selectionStart;
      const end = input.selectionEnd;
      const direction = input.selectionDirection;
      input.type = visible ? 'text' : 'password';
      toggle.setAttribute('aria-pressed', String(visible));
      toggle.setAttribute('aria-label', visible ? toggle.dataset.hideLabel : toggle.dataset.showLabel);
      showIcon.toggleAttribute('hidden', visible);
      hideIcon.toggleAttribute('hidden', !visible);
      if (focused === input) input.focus({ preventScroll: true });
      if (start !== null && end !== null) input.setSelectionRange(start, end, direction);
    }
    toggle.addEventListener('pointerdown', (event) => {
      if (document.activeElement === input) event.preventDefault();
    });
    toggle.addEventListener('click', () => { setVisible(input.type === 'password'); });
    input.form.addEventListener('submit', () => { setVisible(false); });
    root.querySelector('.cb-launch__password').addEventListener('toggle', (event) => {
      if (event.currentTarget.open) input.focus({ preventScroll: true });
      else setVisible(false);
    });
    toggle.hidden = false;
  }
  function initialiseCommunitySignup(root) {
    const primary = root.querySelector('[data-omnisend-primary]');
    const fallback = root.querySelector('[data-native-signup]');
    if (!primary || !fallback) return;
    if (fallback.querySelector('[data-native-result]')) {
      primary.hidden = true;
      return;
    }
    let started = false;
    let observer;
    function keepNativeSignup() {
      started = true;
      primary.hidden = true;
      if (observer) observer.disconnect();
    }
    fallback.addEventListener('input', keepNativeSignup, { once: true });
    function useOmnisendIfReady() {
      if (started || !root.isConnected) return;
      const email = primary.querySelector('input[type="email"]:not([disabled])');
      const submit = primary.querySelector('button[type="submit"]:not([disabled]), input[type="submit"]:not([disabled]), button:not([type]):not([disabled])');
      if (!email || !submit || !email.getClientRects().length || !submit.getClientRects().length) return;
      if (getComputedStyle(email).visibility === 'hidden' || getComputedStyle(submit).visibility === 'hidden') return;
      fallback.hidden = true;
      if (observer) observer.disconnect();
    }
    observer = new MutationObserver(useOmnisendIfReady);
    observer.observe(primary, { childList: true, subtree: true, attributes: true });
    useOmnisendIfReady();
    window.addEventListener('load', useOmnisendIfReady, { once: true });
  }
  function initialiseCommunityLaunch(root) {
    if (root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';
    initialiseCommunityPassword(root);
    initialiseCommunitySignup(root);
    const opens = Date.parse(root.dataset.opens);
    const closes = Date.parse(root.dataset.closes);
    const labels = JSON.parse(root.querySelector('[data-launch-labels]').textContent);
    const timer = root.querySelector('[data-countdown]');
    const timerLabel = root.querySelector('[data-countdown-label]');
    const status = root.querySelector('[data-launch-status]');
    if (!Number.isFinite(opens) || !Number.isFinite(closes) || closes <= opens) {
      timer.hidden = true;
      timerLabel.hidden = true;
      return;
    }
    let interval;
    function update() {
      if (!root.isConnected) { clearInterval(interval); return; }
      const now = Date.now();
      if (now >= closes) {
        timer.hidden = false;
        timerLabel.hidden = false;
        timerLabel.textContent = labels.closes;
        root.querySelectorAll('[data-unit]').forEach((item) => { item.textContent = '00'; });
        status.textContent = labels.closed;
        status.hidden = false;
        root.querySelectorAll('[data-community-offer]').forEach((item) => { item.hidden = true; });
        clearInterval(interval);
        return;
      }
      timer.hidden = false;
      timerLabel.hidden = false;
      const isOpen = now >= opens;
      timerLabel.textContent = isOpen ? labels.closes : labels.opens;
      status.textContent = '';
      status.hidden = true;
      const total = Math.max(0, Math.ceil(((isOpen ? closes : opens) - now) / 1000));
      const values = { days: Math.floor(total / 86400), hours: Math.floor(total / 3600) % 24, minutes: Math.floor(total / 60) % 60, seconds: total % 60 };
      Object.keys(values).forEach((key) => { root.querySelector('[data-unit="' + key + '"]').textContent = String(values[key]).padStart(2, '0'); });
    }
    update();
    if (Date.now() < closes) interval = setInterval(update, 1000);
  }
  document.querySelectorAll('[data-community-launch]').forEach(initialiseCommunityLaunch);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-community-launch]').forEach(initialiseCommunityLaunch);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-hero"] && !Shopify.designMode) return;
  try {
    
  class KitShoppableHero extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      const signal = this.abortController.signal;

      if (window.theme && window.theme.sections) {
        this.initQuickShop();
      } else {
        document.addEventListener('page:loaded', () => this.initQuickShop(), { once: true, signal });
      }

      if (this.querySelector('kit-popover')) {
        window.addEventListener('scroll', () => {
          this.querySelectorAll('kit-popover:popover-open').forEach(p => p.hidePopover());
        }, { passive: true, signal });
      }

      if (!Shopify.designMode) return;

      document.addEventListener('shopify:section:load', (event) => {
        if (event.target.contains(this)) {
          this.initQuickShop();
        }
      }, { signal });

      this.addEventListener('shopify:block:select', (event) => {
        this.initQuickShop();
        const btn = event.target.querySelector('button');
        if (btn) btn.click();
      }, { signal });

      this.addEventListener('shopify:block:deselect', (event) => {
        const popover = event.target.querySelector('kit-popover');
        if (popover) popover.hidePopover?.();
      }, { signal });
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    initQuickShop() {
      if (!theme.settings.quickView) return;

      var sectionEl = this.closest('[id^="shopify-section-"]');
      var links = this.querySelectorAll('.shoppable-hero__popover-link[data-product-handle]');
      if (!links.length) return;

      links.forEach(link => {
        if (link.dataset.shoppableHeroBound === 'true') return;
        link.dataset.shoppableHeroBound = 'true';

        var handle = link.dataset.productHandle;
        var productId = link.dataset.productId;

        if (!document.getElementById('QuickShopModal-' + productId)) return;

        // Capture-phase interceptor registered before modal binds its handler.
        // On mobile, blocks the modal handler so the link navigates normally.
        link.addEventListener('click', (event) => {
          if (theme.config.bpSmall) {
            event.stopImmediatePropagation();
            return;
          }
          const popover = event.target.closest('kit-popover');
          if (popover) popover.hidePopover?.();
        }, true);

        var hotspot = link.closest('.kit-shoppable-hero__hotspot');
        if (!hotspot) return;

        var preloadOnce = function() {
          if (link.dataset.shoppableHeroPreloaded === 'true') return;
          if (theme.config.bpSmall) return;

          // If a holder already exists from another section (e.g. product grid),
          // remove our duplicate modal shell to avoid duplicate IDs
          var holder = document.getElementById('QuickShopHolder-' + handle);
          if (holder && sectionEl) {
            var holderSection = holder.closest('[id^="shopify-section-"]');
            if (holderSection && holderSection !== sectionEl) {
              var duplicate = sectionEl.querySelector('#QuickShopModal-' + productId);
              if (duplicate) duplicate.remove();
            }
          }

          link.dataset.shoppableHeroPreloaded = 'true';
          link.classList.add('js-modal-open-quick-modal-' + productId);
          theme.preloadProductModal(handle, productId, link);

          hotspot.removeEventListener('mouseover', preloadOnce);
          hotspot.removeEventListener('focusin', preloadOnce);
        };

        hotspot.addEventListener('mouseover', preloadOnce);
        hotspot.addEventListener('focusin', preloadOnce);
      });
    }
  }

  customElements.define('kit-shoppable-hero', KitShoppableHero);

  } catch(e) { console.error(e); }
})();
})();
